import { Grid, styled } from '@mui/material';
import { Fragment } from 'react';

import { H4 } from 'app/components/Typography';
import ProductTableHolder from './shared/ProductTable';

const ContentBox = styled('div')(({ theme }) => ({
  margin: '30px',
  [theme.breakpoints.down('sm')]: { margin: '16px' }
}));

const ProductMaster = () => {
  return (
    <Fragment>
      <ContentBox className='analytics'>
        <H4 sx={{ my: 2 }}>Product Master</H4>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <ProductTableHolder />
          </Grid>
        </Grid>
      </ContentBox>
    </Fragment>
  );
};

export default ProductMaster;
